const DpoPodatZadost = {
    init: function () {
        const tlacitko = $("#tlacitkoPodatZadost");
        if (tlacitko.length) {
            tlacitko
                .off("click")
                .on("click", function (e) {
                    e.preventDefault();
                    const titul = $("#idItem");
                    if (!titul.length) {
                        return;
                    }

                    localStorage.setItem("titulId", titul.val());

                    let url = window.location.protocol + "//" + window.location.host;
                    url += "/section/zadosti/item/add/";

                    window.location.href = url;
                });
        }

        const elementTitul = $("#dotacnititul");
        if (!elementTitul.length) {
            return;
        }

        const titulId = localStorage.getItem("titulId");
        if (!titulId) {
            return;
        }

        localStorage.removeItem("titulId");
        elementTitul.val(titulId);
        elementTitul.trigger("change");
    }
}

$(document).ready(function () {
    DpoPodatZadost.init();
});